import { message } from "antd";
import axios from "axios";
import { create } from "zustand";

export const useUnits = create((set, get) => ({
    units: [],
    ed: {},
    columns: [
        {
            title: 'Nomi',
            dataIndex: 'nameuz',
            key: 'nameuz'
        },
        {
            title: 'Nomi',
            dataIndex: 'nameru',
            key: 'nameru'
        },
        {
            title: "Qisqartma UZ",
            dataIndex: 'shortuz',
            key: 'shortuz',
        },
        {
            title: "Qisqartma RU",
            dataIndex: 'shortru',
            key: 'shortru',
        }
    ],
    setEd: (v) => {
        set({ ed: v })
    },
    getUnits: () => {
        axios.get('/units').then(res => {
            set({ units: res.data })
        })
    },
    createUnit: (v) => {
        axios.post('/units', v).then(res => {
            get().getUnits()
            message.success("Muvaffaqiyatli qo'shildingiz!")
        })
    },
    deleteUnit: (id) => {
        axios.delete(`/units/${id}`).then(res => {
            get().getUnits()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        })
    },
    updateUnit: (v) => {
        axios.put(`/units/${v.id}`, v).then(res => {
            get().getUnits()
            message.success("Muvaffaqiyatli o'zgartirdingiz!")
        })
    }
}))